import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
export let BusinessGoalsOption;

(function (BusinessGoalsOption) {
  BusinessGoalsOption["GrowCustomerBase"] = "grow-customer-base";
  BusinessGoalsOption["CreateContent"] = "create-content";
  BusinessGoalsOption["ImproveOnlinePresence"] = "improve-online-presence";
  BusinessGoalsOption["CloseDeals"] = "close-deals";
  BusinessGoalsOption["UnderstandBusiness"] = "understand-my-business";
  BusinessGoalsOption["ImproveBusinessProcess"] = "improve-business-process";
  BusinessGoalsOption["BetterCustomerExperience"] = "better-customer-experience";
  BusinessGoalsOption["ConvertVistorsToCustomers"] = "convert-visitors-to-customers";
})(BusinessGoalsOption || (BusinessGoalsOption = {}));

export const HubInterestToBusinessGoal = {
  [HubInterestOption.Marketing]: [BusinessGoalsOption.GrowCustomerBase, BusinessGoalsOption.CreateContent, BusinessGoalsOption.ImproveOnlinePresence],
  [HubInterestOption.Sales]: [BusinessGoalsOption.CloseDeals, BusinessGoalsOption.UnderstandBusiness, BusinessGoalsOption.ImproveBusinessProcess],
  [HubInterestOption.CustomerService]: [BusinessGoalsOption.BetterCustomerExperience, BusinessGoalsOption.ImproveBusinessProcess, BusinessGoalsOption.UnderstandBusiness],
  [HubInterestOption.CMS]: [BusinessGoalsOption.ImproveOnlinePresence, BusinessGoalsOption.ConvertVistorsToCustomers, BusinessGoalsOption.UnderstandBusiness]
};